import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';

import { Bondsman } from './bondsman';
import { AuthenticationService } from '../shared/authentication.service';
import { EventService } from '../shared/event.service';
import { DatePipe } from '@angular/common';
import { BondsmanSearchResponse } from './bondsman-search-response';
import { environment } from 'environments/environment';
import { BondsmanIdentifier } from '../shared/bondsman-identifier';
import { BondsmanSearchService } from './bondsman-search.service';
import { CivilSearchService } from '../civil/civil-search.service';
import { FileNumberUtil } from '../shared/file-number-util';

enum BondsmanAccordionType {
  License_Number = 'LICENSE_NUMBER',
  Surety_Name = 'SURETY_NAME'
}

enum BondsmanSearchType {
  License_Number_Search = 'Search_by_License_Number',
  Surety_Name_Search = 'Search_by_Surety_Name',
}
@Component({
  selector: 'app-bondsman',
  templateUrl: './bondsman.component.html',
  styleUrls: ['./bondsman.component.less']
})
export class BondsmanComponent implements OnInit {
  enums = {
    BondsmanAccordionType: BondsmanAccordionType,
    BondsmanSearchType: BondsmanSearchType
  }

  submitted = false;
  errors: string[] = [];
  bondsmanSearchFormGroup: FormGroup;
  openAccordion: BondsmanAccordionType = BondsmanAccordionType.Surety_Name;
  bondsmanSearchResponse: BondsmanSearchResponse;
  requestSubscription: Subscription;
  lastSubmittedSearchType: BondsmanSearchType;
  searchCriteriaDescription: string;
  searchRecordLastUpdateDate$: Observable<String>;

  searchModes: string[] = [
    'Exact Match',
    'Begins With'
  ];
  isSearchDivOpen = true;
  showFieldCodeFlag = false;

  constructor(private authenticationService: AuthenticationService,
              private bondsmanSearchService: BondsmanSearchService,
              private civilSearchService: CivilSearchService,
              private eventService: EventService,
               private formBuilder: FormBuilder,
               private route: ActivatedRoute,
               private datePipe: DatePipe) {

    this.searchRecordLastUpdateDate$ = this.civilSearchService.getSearchRecordLastUpdateDate();
  }

  ngOnInit() {
    this. bondsmanSearchFormGroup = this.formBuilder.group( {
      pageNumber: [],
      licenseNumberSearchGroup: this.formBuilder.group({
        licenseNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(1), Validators.pattern(/^[0-9]*$/gm)]]
      }),
      suretyNameSearchGroup: this.formBuilder.group({
        searchBusinessNames: [false, []],
        businessName: ['', []],
        firstName: ['', []],
        middleName: ['', []],
        lastName: ['', []],
        searchNameMatchType: ['Begins With']
      })
    });

    // conditional validation
    this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchBusinessNames').valueChanges.subscribe(
      (searchBusinessNames: boolean) => {
        if (searchBusinessNames) {
          this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').setValidators([Validators.required]);
          this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').setValidators([]);
          this.eventService.focusField('bondsman-business-name-input');
        } else {
          this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').setValidators([]);
          this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').setValidators([Validators.required]);
          this.eventService.focusField('bondsman-last-name-input');
        }
        this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').updateValueAndValidity();
        this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').updateValueAndValidity();
        this.submitted = false; // submitted done
   });

    this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup').disable();

    this.resetForms();
  }

  selectAccordion(type: BondsmanAccordionType, event: any): void {
    const numberSearchAccordionHead: HTMLElement = document.getElementById('bondsman-search-criteria-overhead-search-by-license-number');
    const nameSearchAccordionHead: HTMLElement = document.getElementById('bondsman-search-criteria-overhead-search-by-other');

    if (type === this.openAccordion) {
      event.stopPropagation();

      // toggle to open another accordion and close this opened one
      if (type === BondsmanAccordionType.License_Number) {
        nameSearchAccordionHead.click();
      } else {
        numberSearchAccordionHead.click();
      }

      return;
    }

    // set accordion type and reset
    this.openAccordion = type;
    if (type === BondsmanAccordionType.License_Number) {
      this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup').enable();
      this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').setValidators(
        [Validators.required, Validators.maxLength(10), Validators.minLength(1), Validators.pattern(/^\s*[0-9]{1,10}\s*$/)]);
      this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').updateValueAndValidity();

      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup').disable();
      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').setValidators([]);
      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').setValidators([]);
      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').updateValueAndValidity();
      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').updateValueAndValidity();

      this.eventService.focusField('bondsman-search-number-input');
    } else if (type === BondsmanAccordionType.Surety_Name) {
      this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup').disable();
      this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').setValidators([]);
      this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').updateValueAndValidity();

      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup').enable();
      if (this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchBusinessNames').value === true) {
        this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').setValidators([Validators.required]);
        this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').setValidators([]);
        this.eventService.focusField('bondsman-business-name-input');
      } else {
        this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').setValidators([]);
        this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').setValidators([Validators.required]);
        this.eventService.focusField('bondsman-last-name-input');
      }
      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').updateValueAndValidity();
      this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').updateValueAndValidity();
    }

    // reset summitted status
    this.errors = [];
    this.bondsmanSearchFormGroup.updateValueAndValidity();
    this.submitted = false;
  }

  selectMatchType(value: string) {
    const control: AbstractControl = this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchNameMatchType');
    control.setValue(value);
  }

  onSearch() {
    this.bondsmanSearchResponse = null;
    this.searchCriteriaDescription = null;
    this.resetPageNumbers();
    this.search();
  }

  onStartOver() {
    this.errors = [];
    this.resetForms();
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }

    this.submitted = false;
    this.bondsmanSearchResponse = null;
    this.searchCriteriaDescription = null;
    this.lastSubmittedSearchType = null;
  }

  private resetForms() {
    this.bondsmanSearchFormGroup.reset();
    this.bondsmanSearchFormGroup.setErrors(null);
    this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchNameMatchType').setValue('Begins With');
    this.resetPageNumbers();

    // const userCounty = this.authenticationService.getCurrentUser().authorization.geoName;
    // this.bondsmanSearchFormGroup.get('county').setValue(userCounty);

    // set default focus
    if (this.openAccordion === BondsmanAccordionType.License_Number) {
      this.eventService.focusField('bondsman-license-number-input');
    } else {
      if (this.bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchBusinessNames').value === true) {
        this.eventService.focusField('bondsman-business-name-input');
      } else {
        this.eventService.focusField('bondsman-last-name-input');
      }
    }
  }

  private resetPageNumbers() {
    this.bondsmanSearchFormGroup.get('pageNumber').setValue(null);
  }

  private search(gettingNext = false) {
    this.errors = [];

    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }

    // set submited flag value
    this.submitted = true;
    if (!this.bondsmanSearchFormGroup.valid) {
        console.log('error occurs');
        return;
    }
    this.submitted = false; // TODO: is this the best way to manage the submitted flag?

    // set last ssearch type
    if (this.openAccordion === BondsmanAccordionType.License_Number) {
      this.lastSubmittedSearchType = BondsmanSearchType.License_Number_Search;
    } else {
      this.lastSubmittedSearchType = BondsmanSearchType.Surety_Name_Search;
    }

    this.requestSubscription = this.invokeSearchService(this.lastSubmittedSearchType)
        .subscribe(searchResults => {
          this.handleSearchResult(searchResults, this.lastSubmittedSearchType);
        },
        (errorMessage: string) => this.errors.push(errorMessage));

    this.scrollToTop();
  }

  private invokeSearchService(searchType: BondsmanSearchType): Observable<BondsmanSearchResponse> {
    switch (searchType) {
      case BondsmanSearchType.License_Number_Search: {
        // form the identifier and search criteria description
        const licenseNumber =
           (this.bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').value + '').toUpperCase();
        this.searchCriteriaDescription = ' License Number = "' + licenseNumber + '"';
       // do the search
        return this.bondsmanSearchService.searchBondsmanByLicenseNumber(licenseNumber);
      }
      case BondsmanSearchType.Surety_Name_Search: {
        // form the search criteria description
         this.searchCriteriaDescription = this.getSearchCriteriaDescription(this.bondsmanSearchFormGroup.value);

        // do the search
        return this.bondsmanSearchService.searchBondsmanByName(this.bondsmanSearchFormGroup.value);
      }
    }
  }

  private handleSearchResult(result: BondsmanSearchResponse, searchType: BondsmanSearchType): void {
    if (searchType === BondsmanSearchType.License_Number_Search) {
      // if (this.bondsmanSearchResponse === null) {
      //   this.bondsmanSearchResponse = new BondsmanSearchResponse();
      // }
      // this.bondsmanSearchResponse.bondsmanList = [result as Bondsman];
      this.bondsmanSearchResponse = result;
    } else {
      let resultInput = result as BondsmanSearchResponse;
      if (resultInput.pageNumber > 1) {
         resultInput.bondsmanList.unshift(...this.bondsmanSearchResponse.bondsmanList);
      }
      this.bondsmanSearchResponse = resultInput;
    }
  }


  private getSearchCriteriaDescription(bondsmanSearchForm: any): string {
    const criteria = [];
    const searchForm = bondsmanSearchForm.suretyNameSearchGroup; // name search form

    if (searchForm.searchBusinessNames && searchForm.businessName) {
      const businessNm: string = FileNumberUtil.normalizeRegularString(searchForm.businessName.toUpperCase());
      criteria.push('Business Name = "' + businessNm + '" (' + searchForm.searchNameMatchType + ')');
    } else {
      if (searchForm.firstName) {
        const firstNm: string = FileNumberUtil.normalizeRegularString(searchForm.firstName.toUpperCase());
        criteria.push('First Name = "' + firstNm + '" (' + searchForm.searchNameMatchType + ')');
      }
      if (searchForm.middleName) {
        const middleNm: string = FileNumberUtil.normalizeRegularString(searchForm.middleName.toUpperCase());
        criteria.push('Middle Name = "' + middleNm + '" (' + searchForm.searchNameMatchType + ')');
      }
      if (searchForm.lastName) {
        const lastNm: string = FileNumberUtil.normalizeRegularString(searchForm.lastName.toUpperCase());
        criteria.push('Last Name = "' + lastNm + '" (' + searchForm.searchNameMatchType + ')');
      }
    }

    const criteriaDescResult = criteria.join('  | ');
    return criteriaDescResult.toString();
  }

  private scrollToTop() {
    // when clicking on search button for party name search
    /*
    if (this.activeSearchResultTab === PartyNameSearchResultTab.Cases
       && !this.caseSearchResults
       && this.errors) {
      document.documentElement.scrollTop = 0;
    } */
  }

  getTotalRecordsDescription(): string {
    if (!this.bondsmanSearchResponse || !this.bondsmanSearchResponse.totalRecords) {
      return '';
    }
    let returnType: string = this.bondsmanSearchResponse.totalRecords === 1 ? 'bondsman' : 'Bondsman';
    return (this.bondsmanSearchResponse.totalRecords).toLocaleString() + ' ' + returnType + '  found';
  }

  getDisplayedRecordsDescription(): string {
    if (!this.bondsmanSearchResponse || !this.bondsmanSearchResponse.totalRecords) {
      return '';
    }
    return (this.bondsmanSearchResponse.pageNumber * 50 ).toLocaleString()
    + ' of ' + (this.bondsmanSearchResponse.totalRecords).toLocaleString()
    + ' ' + this.bondsmanSearchResponse + ' are being displayed. ';
  }

  getBondsmanSearchRecords(): Bondsman[] {
    return this.bondsmanSearchResponse && this.bondsmanSearchResponse.bondsmanList;
  }

  doesBondsmanSearchHaveMoreRecords(): boolean {
    return !!this.bondsmanSearchResponse &&
        (this.bondsmanSearchResponse.totalRecords >
         this.bondsmanSearchResponse.pageNumber * this.bondsmanSearchResponse.pageSize);
  }

  getNextBondsmanSearchRecords() {
    this.searchCriteriaDescription = null;
    this.bondsmanSearchFormGroup.get('pageNumber').setValue(this.bondsmanSearchResponse.pageNumber + 1);
    this.search(true);
  }

  /**
   * check if the case number accordion is open
   */
  isLicenseNumberAccordionOpen(): boolean {
    return this.openAccordion === BondsmanAccordionType.License_Number;
  }

  isRequestInFlight(): boolean {
    return this.requestSubscription &&
           !this.requestSubscription.closed;
  }

  private buildIMultiSelectOptions(items: string[]): IMultiSelectOption[] {
    return items.map(i => { return {'id': i, 'name': i }; });
  }

  openDisclaimer() {
    console.log('access the opening disclainer');
    this.eventService.openDisclaimer();
  }

  isProd(): boolean {
     return environment.production;
  }

  toggleFieldCodes() {
    this.showFieldCodeFlag = !this.showFieldCodeFlag;
    $('.field-code').toggle();
  }

  /**
   * toggle to open/close search criteria div
   */
  toggleSearchCriteria() {
    const searchDiv = document.getElementById('bondsman-search-criteria-div');
    const searchDivWidth = searchDiv.clientWidth;
    const resultDiv = document.getElementById('bondsman-search-results-div');
    const resultDivOriginPaddingLeft = 15;
    const resultDivChangePaddingLeft = 35;  // on closing search div

    // before closing search div, set search div transition and reset result div's left padding
    searchDiv.style.transition = 'all .6s';
    if (this.isSearchDivOpen) {
      resultDiv.style.paddingLeft = (searchDivWidth + resultDivOriginPaddingLeft ) + 'px';
    }

    // toggle to open/close search div and reset result div's padding left with transition
    this.isSearchDivOpen = !this.isSearchDivOpen;
    if (!this.isSearchDivOpen) { // search div being closed
       setTimeout(() => {
          resultDiv.style.paddingLeft = resultDivChangePaddingLeft + 'px';
          resultDiv.style.transition = 'all .6s';
       }, 10);
    } else {                     // search div beig opened
       resultDiv.style.paddingLeft = resultDivOriginPaddingLeft  + 'px';
       resultDiv.style.transition = 'all 0s';
    }
  }

  updateValidators(type: BondsmanAccordionType) {

  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman.component.ts